import { render, staticRenderFns } from "./PoliticaUso.vue?vue&type=template&id=b0e690a4&scoped=true"
import script from "./PoliticaUso.vue?vue&type=script&lang=js"
export * from "./PoliticaUso.vue?vue&type=script&lang=js"
import style0 from "./PoliticaUso.vue?vue&type=style&index=0&id=b0e690a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e690a4",
  null
  
)

export default component.exports